var _storage = window.sessionStorage;
var CART = {
  order_id: null,
  discount: null,
  voucher: 0,
  items: [],
  init: function () {
    var items = _storage.getItem("shopping_cart");
    if (items) {
      var parsed = JSON.parse(items);
      CART.items = parsed.items;
      CART.order_id = parsed.order_id;
      CART.discount = parsed.discount;
      CART.voucher = parsed.voucher;
    }
  },
  cartLength: function () {
    return CART.items.length || 0;
  },
  getItem: function (id) {
    return CART.items.find((i) => i.id == id) || {};
  },
  addToCart: function (item) {
    var idx = CART.items.findIndex((inner) => inner.id == item.id);
    if (this.voucher) {
      item.date = "";
    }

    if (idx === -1) {
      this.items.push(item);
    } else {
      this.items[idx] = item;
    }
  },
  addDiscount: function (data) {
    CART.discount = data;
    CART.saveCart();
  },
  addVoucher: function (data) {
    CART.voucher = data;
    CART.saveCart();
  },
  saveCart: function () {
    _storage.setItem("shopping_cart", JSON.stringify(CART));
    APP.updateMenuBadgeNumber(".menu-cart", CART.cartLength());
  },
  removeItem: function (id) {
    var idx = CART.items.findIndex((i) => i.id == id);
    if (idx != -1) {
      CART.items.splice(idx, 1);
    }
    CART.saveCart();
    if (APP.page == "cart") {
      CART.drawCart();
    }
  },
  drawCart: function () {
    var templateHtml = $("#cart-item").html();
    var template = Handlebars.compile(templateHtml);
    $(".items-group").html("");

    if (CART.voucher) {
      console.log("🚀 ~ file: cart.js:59 ~ CART.voucher:", CART.voucher);
      $(".tx-checkout-title").html(TOKEN.VOUCHER_CHECKOUT_TITLE);
      console.log(
        "🚀 ~ file: cart.js:63 ~ TOKEN.VOUCHER_CHECKOUT_TITLE:",
        TOKEN.VOUCHER_CHECKOUT_TITLE
      );
    }

    var items = _.cloneDeep(CART.items).reverse();
    if (items.length == 0) {
      $(".items-group").html(
        '<div class="no-results">' + TOKEN.EMPTY_CART + "</div>"
      );
      $("#section-cart .button").addClass("is-hidden");
    } else {
      $("#section-cart .button.is-hidden").removeClass("is-hidden");
    }
    for (let i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.extras.schedule) {
        item.schedule = (
          item.extras.schedule.children.find(
            (child) => child.content_id == item.extras.schedule.value
          ) || { name: "" }
        ).name;
      }

      item.person_text = item.extras.person.value + " " + TOKEN.ADULTS;

      if (_.has(item.extras, "children.value")) {
        if (item.extras.children.value > 0) {
          item.person_text +=
            " + " + item.extras.children.value + " " + TOKEN.CHILDREN;
        }
      }

      if (
        Object.keys(item.extras).find((extra) =>
          "children_price_kid".indexOf(extra.id)
        ).length
      ) {
        item.children_price_kid = _.chain(item.extras)
          .filter(function (v, k) {
            return (
              !["person", "children", "schedule", "language"].includes(k) &&
              "children_price_kid".indexOf(k) &&
              v.value
            );
          })
          .map(function (extra) {
            var text = _.truncate(extra.name);
            if (extra.type.id == 2) {
              text +=
                ": " +
                _.get(
                  _.find(extra.children, { content_id: extra.value }),
                  "name"
                );
            } else if (extra.type.id == 3) {
              text += ": " + extra.value;
            } else if (extra.type.id == 4) {
              text = extra.value + " " + text;
            }
            return {
              text,
            };
          })
          .value();
      }

      item.extras = _.chain(item.extras)
        .filter(function (v, k) {
          return (
            !["person", "children", "schedule"].includes(k) &&
            !"children_price_kid".indexOf(k) &&
            v.value
          );
        })
        .map(function (extra) {
          var text = _.truncate(extra.name);
          if (extra.type.id == 2) {
            text +=
              ": " +
              _.get(
                _.find(extra.children, { content_id: extra.value }),
                "name"
              );
          } else if (extra.type.id == 3) {
            text += ": " + extra.value;
          }
          return {
            text,
          };
        })
        .value();

      item.voucher = CART.voucher;
      if (item.voucher > 0) {
        item.booking_url = item.booking_url + "?voucher=1";
      }

      item.total_formatted = item.total.toFixed(2);
      console.log("🚀 ~ file: cart.js:151 ~ item:", item);
      $(".items-group").append(
        template({
          ...item, TOKEN: {
            REMOVE: TOKEN.REMOVE,
            EDIT: TOKEN.EDIT,
            TOTAL: TOKEN.TOTAL,
            PRE_BOOKING: TOKEN.PRE_BOOKING
          }
        })
      );
    }
    var templateHtml = $("#cart-total").html();
    var template = Handlebars.compile(templateHtml);
    var total = _.sumBy(items, "total");
    $(".items-total").html(template({
      total: total.toFixed(2),
      TOKEN: {
        TOTAL: TOKEN.TOTAL,
        CHECKOUT: TOKEN.CHECKOUT,
      },
    }));

  },
  clear: function () {
    CART.items = [];
    CART.order_id = null;
    CART.discount = null;
    CART.voucher = 0;
    CART.saveCart();
  },
};
